import createAppointmentTpl from './create-appointment.tpl.html!text';

class CreateAppointmentCtrl {

    constructor($scope, $element, storeServ) {
        this.$scope = $scope;
        this.$element = $element;
        this.storeServ = storeServ;

        this.shopAppointmentIntervals = [];
        this.intervalsCorrespondingToTheSelectedDate = [];

        this.appointmentFormModels = {
            date: null,
            hour: null,
            firstName: null,
            lastName: null,
            email: null,
            phoneNo: null,
            reason: null,
            newsletter: false,
            termsAndCs: false
        };

        this.subscribeToStore();

        this.addComponentDestroyListener();
    }

    subscribeToStore() {
        this.unsubscribeFromStore = this.storeServ.subscribe(this.onStateChange.bind(this));
    }

    addComponentDestroyListener() {
        this.$scope.$on('$destroy', this.onDestroyComponent.bind(this));
    }

    onStateChange() {
        this.shopAppointmentIntervals = this.storeServ.getState().shopAppointmentIntervals;
    }

    onDestroyComponent() {
        this.unsubscribeFromStore();
    }
}

CreateAppointmentCtrl.$inject = ['$scope', '$element', 'storeServ'];

var createAppointmentComponent = function() {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        template: createAppointmentTpl,
        scope: {},
        controller: CreateAppointmentCtrl,
        controllerAs: 'createAppointmentCtrl'
    };
};

export default createAppointmentComponent;